import * as React from 'react'

function MoneySearchIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.828 19.839a4 4 0 11-5.558 5.756 4 4 0 015.558-5.756M29.333 28l-2.505-2.504M17.885 10.115a2.665 2.665 0 01-.843 4.386 2.666 2.666 0 11.843-4.386M8.667 10v4M23.333 10v4"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.667 20h-8A2.667 2.667 0 014 17.333V6.667A2.667 2.667 0 016.667 4h18.666A2.667 2.667 0 0128 6.667v8"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { MoneySearchIcon }
